import { Routes } from '@angular/router';
import { autenticato } from '@shared/guardie/autenticato.guard';
import { ProfileComponent } from '@modules/settings/profiles/profile.component';
import { RolesComponent } from '@modules/settings/roles/roles.component';
import { UsersComponent } from '@modules/settings/users/users.component';

export const settingsRoutes: Routes = [
  {
    path: 'settings/users',
    canActivate: [autenticato],
    component: UsersComponent,
    data: {
      breadcrumb: {
        label: 'Gestione Utenti',
      },
    },
  },
  {
    path: 'settings/roles',
    canActivate: [autenticato],
    component: RolesComponent,
    data: {
      breadcrumb: {
        label: 'Gestione Ruoli',
      },
    },
  },
  {
    path: 'settings/profile',
    canActivate: [autenticato],
    component: ProfileComponent,
    data: {
      breadcrumb: {
        label: 'Profilo',
      },
    },
  }
];
